import { jsxs, jsx } from "react/jsx-runtime";
const IconHome = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 2.09998L1 12H4V21H11V15H13V21H20V12H23L12 2.09998ZM18 19H15V13H9V19H6V10.19L12 4.68998L18 10.19V19Z",
        fill: "currentColor"
      }
    )
  }
);
const IconSidebar = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: Math.round(size * 20 / 24),
    viewBox: "0 0 24 20",
    fill: "none",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4.07715 0.0996094H19.9229C20.9788 0.0996279 21.9907 0.504276 22.7363 1.22266C23.4818 1.94096 23.9004 2.91453 23.9004 3.92871V16.0713C23.9004 17.0855 23.4818 18.059 22.7363 18.7773C21.9907 19.4957 20.9788 19.9004 19.9229 19.9004H4.07715C3.0212 19.9004 2.00926 19.4957 1.26367 18.7773C0.518186 18.059 0.0996094 17.0855 0.0996094 16.0713V3.92871C0.0996094 2.91453 0.518186 1.94096 1.26367 1.22266C2.00926 0.504276 3.0212 0.0996276 4.07715 0.0996094ZM4.07715 2.04297C3.56031 2.04299 3.06382 2.24056 2.69727 2.59375C2.33057 2.94708 2.12402 3.42736 2.12402 3.92871V16.0713C2.12402 16.5726 2.33057 17.0529 2.69727 17.4062C3.06382 17.7594 3.56031 17.957 4.07715 17.957H6.03027V2.04297H4.07715ZM8.05469 17.957H19.9229C20.4397 17.957 20.9362 17.7594 21.3027 17.4062C21.6694 17.0529 21.876 16.5726 21.876 16.0713V3.92871C21.876 3.42736 21.6694 2.94708 21.3027 2.59375C20.9362 2.24056 20.4397 2.04299 19.9229 2.04297H8.05469V17.957Z",
        fill: "currentColor"
      }
    )
  }
);
const IconCompose = ({ size = 20, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.95216 19.6877C5.99369 19.6794 6.03672 19.6865 6.07357 19.7074C7.55917 20.5512 9.24531 21 11 21C13.4663 21 15.7971 20.1133 17.6265 18.4899C17.7783 18.3552 17.9265 18.2154 18.071 18.071C19.96 16.1824 21 13.6713 21 11C21 8.32909 19.96 5.81806 18.071 3.92901C16.1966 2.05461 13.6654 1.00374 11.0146 1.00001C8.33826 0.996234 5.821 2.03706 3.92905 3.92901C3.78461 4.07349 3.64481 4.22167 3.51012 4.37358C1.88672 6.20337 1 8.53366 1 11C1 12.8347 1.49071 14.5937 2.41 16.1274C2.43403 16.1675 2.44137 16.2153 2.43 16.2606L1.60577 19.5527C1.54751 19.7857 1.61324 20.0322 1.77909 20.206C1.91237 20.3449 2.10817 20.4713 2.45494 20.3876L5.95216 19.6877Z",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M8.44141 11.0098H13.5451", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M11.0039 8.44531V13.549", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconImageUpload = ({ size = 24, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.342 23.9893H8.64729C2.58861 23.9893 0 21.4007 0 15.342V8.64729C0 2.58861 2.58861 0 8.64729 0H15.342C21.4007 0 23.9893 2.58861 23.9893 8.64729V15.342C23.9893 21.4007 21.4007 23.9893 15.342 23.9893ZM8.64729 1.67367C3.50355 1.67367 1.67367 3.50355 1.67367 8.64729V15.342C1.67367 20.4857 3.50355 22.3156 8.64729 22.3156H15.342C20.4857 22.3156 22.3156 20.4857 22.3156 15.342V8.64729C22.3156 3.50355 20.4857 1.67367 15.342 1.67367H8.64729Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.64728 10.5999C6.9513 10.5999 5.57889 9.2275 5.57889 7.53151C5.57889 5.83553 6.9513 4.46312 8.64728 4.46312C10.3433 4.46312 11.7157 5.83553 11.7157 7.53151C11.7157 9.2275 10.3433 10.5999 8.64728 10.5999ZM8.64728 6.13679C7.8774 6.13679 7.25256 6.76162 7.25256 7.53151C7.25256 8.3014 7.8774 8.92624 8.64728 8.92624C9.41717 8.92624 10.042 8.3014 10.042 7.53151C10.042 6.76162 9.41717 6.13679 8.64728 6.13679Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.58414 20.5863C1.31636 20.5863 1.04857 20.4524 0.892361 20.218C0.635731 19.8387 0.736151 19.3143 1.12667 19.0576L6.62747 15.3644C7.83251 14.5499 9.49502 14.6503 10.5885 15.5764L10.9567 15.9C11.5146 16.3798 12.463 16.3798 13.0098 15.9L17.6514 11.9166C18.8341 10.9013 20.6975 10.9013 21.8914 11.9166L23.7101 13.4787C24.056 13.78 24.1006 14.3044 23.7994 14.6615C23.4981 15.0074 22.9737 15.052 22.6166 14.7507L20.7979 13.1886C20.24 12.7088 19.2916 12.7088 18.7337 13.1886L14.0921 17.172C12.9093 18.1873 11.046 18.1873 9.85211 17.172L9.48387 16.8484C8.97061 16.4132 8.12261 16.3686 7.55357 16.7591L2.05277 20.4524C1.90772 20.5416 1.74035 20.5863 1.58414 20.5863Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconMicrophone = ({
  size = 17,
  height = 24,
  className,
  style
}) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.5 17.1429C5.68778 17.1429 3.4 14.8359 3.4 12V5.14286C3.4 2.307 5.68778 0 8.5 0C11.3122 0 13.6 2.307 13.6 5.14286V12C13.6 14.8359 11.3122 17.1429 8.5 17.1429ZM8.5 1.71429C6.62533 1.71429 5.1 3.25243 5.1 5.14286V12C5.1 13.8904 6.62533 15.4286 8.5 15.4286C10.3747 15.4286 11.9 13.8904 11.9 12V5.14286C11.9 3.25243 10.3747 1.71429 8.5 1.71429ZM16.15 10.2857C15.6806 10.2857 15.3 10.6695 15.3 11.1429V12C15.3 15.7811 12.2496 18.8571 8.5 18.8571C4.75044 18.8571 1.7 15.7811 1.7 12V11.1429C1.7 10.6695 1.31941 10.2857 0.85 10.2857C0.380587 10.2857 0 10.6695 0 11.1429V12C0 16.4372 3.36069 20.0966 7.65 20.5279V22.2857H5.95C5.48059 22.2857 5.1 22.6695 5.1 23.1429C5.1 23.6162 5.48059 24 5.95 24H11.05C11.5194 24 11.9 23.6162 11.9 23.1429C11.9 22.6695 11.5194 22.2857 11.05 22.2857H9.35V20.5279C13.6393 20.0964 17 16.437 17 12V11.1429C17 10.6695 16.6194 10.2857 16.15 10.2857Z",
        fill: "currentColor"
      }
    )
  }
);
const IconArrowRight = ({ size = 12, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size * 9 / 12,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.1231 4.03711C11.1229 4.03695 11.1228 4.03675 11.1226 4.03659L8.22563 1.16103C8.0086 0.945614 7.65757 0.946414 7.44154 1.1629C7.22553 1.37938 7.22637 1.72952 7.44339 1.94495L9.38841 3.87559H1.55442C1.24822 3.87559 1 4.12315 1 4.42858C1 4.734 1.24822 4.98161 1.55442 4.98161H9.38839L7.44344 6.9122C7.22641 7.12765 7.22557 7.47776 7.44158 7.69423C7.6576 7.91075 8.00867 7.91151 8.22567 7.69612L11.1226 4.82053C11.1228 4.82037 11.1229 4.82017 11.1231 4.82C11.3403 4.60386 11.3396 4.25257 11.1231 4.03712L11.1231 4.03711Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.428571"
      }
    )
  }
);
const IconHamburger = ({ size = 32, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6 10h12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 16h20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 22h16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconChats = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.2796 16.1373L19.118 12.7029C19.6779 11.5401 19.9738 10.2468 19.9758 8.94564C19.9792 6.68311 19.1176 4.54385 17.5495 2.92195C15.9812 1.29973 13.8912 0.386554 11.6647 0.35072C9.35587 0.313654 7.18572 1.20584 5.55419 2.86329C3.98099 4.4615 3.10841 6.56846 3.08079 8.81999C1.53024 10.006 0.615044 11.8551 0.618052 13.8301C0.619497 14.7544 0.824263 15.6731 1.21227 16.5039L0.412153 18.8694C0.274614 19.2761 0.375083 19.7176 0.67438 20.0217C0.885006 20.2357 1.1627 20.3496 1.44829 20.3496C1.56844 20.3496 1.69001 20.3295 1.80856 20.2881L4.13704 19.4752C4.95481 19.8694 5.85915 20.0774 6.76892 20.0789C6.7722 20.0789 6.77532 20.0789 6.77861 20.0789C8.75165 20.0788 10.5856 19.1251 11.7488 17.5112C12.9592 17.4788 14.1569 17.1812 15.2396 16.6431L18.6202 17.8232C18.761 17.8724 18.9055 17.8964 19.0483 17.8964C19.3876 17.8964 19.7176 17.761 19.968 17.5066C20.3236 17.1453 20.443 16.6206 20.2796 16.1373ZM6.77853 18.8695C6.77599 18.8695 6.77329 18.8695 6.77075 18.8695C5.96552 18.8682 5.16587 18.6666 4.45841 18.2863C4.31294 18.2082 4.14216 18.1946 3.98661 18.2489L1.59899 19.0824L2.41942 16.6568C2.47286 16.4988 2.45958 16.3253 2.38262 16.1775C2.00833 15.4588 1.80981 14.6464 1.80856 13.8283C1.80657 12.5124 2.31044 11.2652 3.19157 10.3313C3.47938 12.1137 4.3156 13.7563 5.61177 15.0496C6.89837 16.3335 8.51564 17.1509 10.2606 17.4181C9.33923 18.3407 8.0972 18.8695 6.77853 18.8695ZM19.1261 16.6514C19.0923 16.6858 19.0521 16.6952 19.0069 16.6794L15.3879 15.416C15.325 15.394 15.2596 15.3832 15.1945 15.3832C15.0984 15.3832 15.0027 15.4068 14.9161 15.4534C13.8828 16.0087 12.7151 16.3032 11.5393 16.3051C11.5354 16.3051 11.5319 16.3051 11.528 16.3051C7.58806 16.3051 4.33364 13.0536 4.27122 9.05183C4.23978 7.03646 4.99439 5.14237 6.39599 3.71845C7.79759 2.29454 9.66232 1.52819 11.6458 1.55994C15.5887 1.62348 18.7914 4.93581 18.7853 8.94373C18.7835 10.1383 18.4936 11.3246 17.947 12.3743C17.87 12.522 17.8567 12.6955 17.9102 12.8536L19.1537 16.5303C19.1692 16.5763 19.1599 16.6171 19.1261 16.6514Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.7"
      }
    )
  }
);
const IconChevronUp = ({ size = 24, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18 15l-6-6-6 6",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
const IconClose = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx("path", { d: "M15.5 4.5L4.5 15.5M4.5 4.5l11 11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  }
);
export {
  IconArrowRight,
  IconChats,
  IconChevronUp,
  IconClose,
  IconCompose,
  IconHamburger,
  IconHome,
  IconImageUpload,
  IconMicrophone,
  IconSidebar
};
//# sourceMappingURL=ConciergeIcons.js.map
